/* eslint-disable import/prefer-default-export */
import Vue from 'vue';
import dayjs, { Dayjs } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import utc from 'dayjs/plugin/utc';
import warnOfGlobal from './warnOfGlobal';

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);

export const toUTC = (value: string | number | Date | Dayjs | undefined): Dayjs => dayjs.utc(value);

export const date = (value, { showUTC = false } = {}) => {
  if (!value) return false;
  if (!dayjs(value).isValid()) {
    console.warn(`${value} is not a valid date`);
    return false;
  }

  const format = (showUTC) ? 'DD MMM YYYY UTC' : 'DD MMM YYYY';
  return toUTC(value).format(format);
};

export const time = (value, { showUTC = false } = {}) => {
  if (!value) return false;
  if (!dayjs(value).isValid()) {
    console.warn(`${value} is not a valid date`);
    return false;
  }

  const format = (showUTC) ? 'HH:mm UTC' : 'HH:mm';
  return toUTC(value).format(format);
};

/**
 * This will convert a local time to be UTC and display it in our format
*/
export const dateTime = (value, { showUTC = true } = {}) => {
  if (!value) return false;
  const formattedDate = date(value, { showUTC: false }) as string;
  const formattedTime = time(value, { showUTC }) as string;

  if (!formattedDate || !formattedTime) {
    return false;
  }

  return `${formattedDate} ${formattedTime}`;
};

export const fromNow = (value) => dayjs(value).fromNow();

Vue.filter('fromNow', (val) => warnOfGlobal(val, fromNow));
Vue.filter('date', (val) => warnOfGlobal(val, date));
Vue.filter('time', (val) => warnOfGlobal(val, time));
Vue.filter('dateTime', (val) => warnOfGlobal(val, dateTime));
Vue.filter('toUTC', (val) => warnOfGlobal(val, toUTC));
